import React, { ElementType, HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLOrSVGElement> {
  data: ReusableTextField;
  as?: ElementType;
}

function TextComponent({ data, as: Tag = 'p', ...rest }: Props) {
  if (!data) {
    return null;
  }

  return (
    <Tag
      dangerouslySetInnerHTML={{ __html: data.input_text || '' }}
      style={{
        fontSize: data.input_font_size ? `${data.input_font_size}rem` : '',
        lineHeight: data.input_line_height || '',
        color: data.input_font_color || '',
        marginTop: data.margin_top ? `${data.margin_top}rem` : '',
        marginBottom: data.margin_bottom ? `${data.margin_bottom}rem` : '',
      }}
      {...rest}
    ></Tag>
  );
}

export default TextComponent;
